import { render, staticRenderFns } from "./tv-menu-config.vue?vue&type=template&id=72bd5123&"
import script from "./tv-menu-config.vue?vue&type=script&lang=ts&"
export * from "./tv-menu-config.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports